import { CarouselApi } from './ui/carousel';
import { cn } from '@/lib/utils';

export interface CarouselNavDotsProps {
    count: number;
    index: number;
    api?: CarouselApi;
    onSelect?: (index: number) => void;
    className?: string;
    /** `sm` is slightly tighter (e.g. article slider). Default matches landing/production. */
    size?: 'default' | 'sm';
    /** Translated label for each dot, by position. A dot without one falls back to the English "Go to slide N". */
    labels?: string[];
}

export const CarouselNavDots = ({
    count,
    index,
    api,
    onSelect,
    className,
    size = 'default',
    labels,
}: CarouselNavDotsProps) => {
    const compact = size === 'sm';

    return (
        <div className={cn(
            'flex justify-center items-center mt-4',
            compact ? 'gap-3' : 'gap-4',
            className,
        )}
        >
            {Array.from({ length: count }).map((_, i) => {
                const isActive = index === i;
                return (
                    <button
                        key={i}
                        type="button"
                        onClick={() => {
                            if (onSelect) {
                                onSelect(i);
                            }
                            else {
                                api?.scrollTo(i);
                            }
                        }}
                        className={cn(
                            'rounded-full transition-all',
                            isActive
                                ? cn(
                                        'bg-(--nav-dots-selected) border-1 border-(--gz-neutral-600) shadow-[0_2px_4px_0_rgba(92,86,79,0.5)]',
                                        compact ? 'h-3 w-3' : 'h-3.5 w-3.5',
                                    )
                                : cn(
                                        'bg-(--gz-neutral-400)',
                                        compact ? 'h-2.5 w-2.5' : 'h-3 w-3',
                                    ),
                        )}
                        aria-label={labels?.[i] ?? `Go to slide ${i + 1}`}
                        aria-current={isActive ? true : undefined}
                    />
                );
            })}
        </div>
    );
};
